var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcPlansActiveDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.153 11.5216C11.153 10.0964 12.3082 8.94116 13.7333 8.94116H26.2667C27.6918 8.94116 28.8471 10.0964 28.8471 11.5216V12.2588C28.8471 12.8696 28.3519 13.3647 27.7412 13.3647C27.1304 13.3647 26.6353 12.8696 26.6353 12.2588V11.5216C26.6353 11.318 26.4703 11.1529 26.2667 11.1529H13.7333C13.5298 11.1529 13.3647 11.318 13.3647 11.5216V28.4784C13.3647 28.682 13.5298 28.847 13.7333 28.847H26.2667C26.4703 28.847 26.6353 28.682 26.6353 28.4784V16.6823C26.6353 16.0716 27.1304 15.5765 27.7412 15.5765C28.3519 15.5765 28.8471 16.0716 28.8471 16.6823V28.4784C28.8471 29.9035 27.6918 31.0588 26.2667 31.0588H13.7333C12.3082 31.0588 11.153 29.9035 11.153 28.4784V11.5216Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.534 22.5305C24.9688 22.7951 25.1067 23.3621 24.8421 23.7969L23.047 26.7459C22.8973 26.9918 22.6414 27.1536 22.3551 27.1833C22.0688 27.2131 21.7851 27.1074 21.588 26.8976L20.4341 25.6688C20.0856 25.2978 20.1039 24.7146 20.475 24.3662C20.846 24.0178 21.4292 24.0361 21.7776 24.4071L22.1024 24.7529L23.2677 22.8385C23.5323 22.4038 24.0993 22.2659 24.534 22.5305Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9452 14.655C15.9452 14.146 16.3578 13.7334 16.8668 13.7334H23.1334C23.6424 13.7334 24.055 14.146 24.055 14.655V14.655C24.055 15.1639 23.6424 15.5765 23.1334 15.5765H16.8668C16.3578 15.5765 15.9452 15.1639 15.9452 14.655V14.655Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9452 18.3412C15.9452 17.8323 16.3578 17.4197 16.8668 17.4197H23.1334C23.6424 17.4197 24.055 17.8323 24.055 18.3412V18.3412C24.055 18.8502 23.6424 19.2628 23.1334 19.2628H16.8668C16.3578 19.2628 15.9452 18.8502 15.9452 18.3412V18.3412Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcPlansActiveDark);
export default __webpack_public_path__ + "static/media/ic_plans_active_dark.3bac85f64ec758f1fdb6e4793c632a4e.svg";
export { ForwardRef as ReactComponent };